<template>
  <v-scale-transition>
    <wide-panel
      :breadcrumbs="breadcrumbs"
      :title="title"
    >
      <v-toolbar
        card
        extended
      >
        <v-container fluid>
          <v-layout row>
            <v-flex xs5>
              <v-text-field
                v-model="transactionId"
                label="Transaction ID"
                clearable
              />
            </v-flex>
            <v-card-actions>
              <v-spacer />
              <v-btn
                color="primary"
                dark
                class="mb-2"
                @click="refreshList()"
              >
                Search
              </v-btn>
            </v-card-actions>
            <v-dialog
              v-model="deleteTopupDialog"
              max-width="800px"
            >
              <v-card>
                <v-card-title>
                  <span class="headline">Delete Topup Record?</span>
                </v-card-title>
                <v-alert
                  :value="true"
                  type="warning"
                >
                  This action is irreversible! Are you sure you want to delete
                  this record?
                </v-alert>
                <v-card-actions>
                  <v-spacer />
                  <v-btn
                    color="blue darken-1"
                    flat
                    @click="closeAllDialogs(false)"
                  >
                    Cancel
                  </v-btn>
                  <v-btn
                    color="red darken-1"
                    flat
                    @click="deleteTopupRecord"
                  >
                    Delete Topup
                  </v-btn>
                </v-card-actions>
              </v-card>
            </v-dialog>
          </v-layout>
        </v-container>
      </v-toolbar>
      <v-toolbar>
        Topup
      </v-toolbar>
      <v-data-table
        :headers="headers"
        :items="adjustment"
        class="elevation-1"
      >
        <template #items="props">
          <td class="text-xs-left">
            {{ props.item.tarikh }}
          </td>
          <td class="text-xs-left">
            {{ props.item.transactionID }}
          </td>
          <td class="text-xs-left">
            {{ props.item.dealer }}
          </td>
          <td class="text-xs-left">
            {{ props.item.nohp }}
          </td>
          <td class="text-xs-center">
            {{ props.item.amaun }}
          </td>
          <td class="text-xs-right">
            {{ props.item.kaedah }}
          </td>
          <td class="justify-center layout px-0">
            <v-icon
              small
              color="red lighten-2"
              @click="deleteTopup(props.item)"
            >
              mdi-trash-can-outline
            </v-icon>
          </td>
        </template>
      </v-data-table>
      <v-dialog
        v-model="deleteNewsDialog"
        max-width="800px"
      >
        <v-card>
          <v-card-title>
            <span class="headline">Refund Transaction?</span>
          </v-card-title>
          <v-alert
            :value="true"
            type="warning"
          >
            Please ensure that you have  <strong>deleted topup record </strong>from user before refund to dealer! .
          </v-alert>
          <v-card-actions>
            <v-spacer />
            <v-btn
              color="blue darken-1"
              flat
              @click="closeAllDialogs2(false)"
            >
              Cancel
            </v-btn>
            <v-btn
              color="red darken-1"
              flat
              @click="refundErechargeDealer"
            >
              Refund Erecharge
            </v-btn>
          </v-card-actions>
        </v-card>
      </v-dialog>
      <v-toolbar>
        ER Transaction
      </v-toolbar>
      <v-data-table
        :headers="headers2"
        :items="erTransaction"
        class="elevation-1"
      >
        <template #items="props">
          <td class="text-xs-left">
            {{ props.item.date }}
          </td>
          <td class="text-xs-left">
            {{ props.item.dealer }}
          </td>
          <td class="text-xs-left">
            {{ props.item.dreg }}
          </td>
          <td class="text-xs-left">
            {{ props.item.msisdn }}
          </td>
          <td class="text-xs-left">
            {{ props.item.transactionId }}
          </td>
          <td class="text-xs-left">
            {{ props.item.amount }}
          </td>
          <td class="text-xs-center">
            {{ props.item.transType }}
          </td>
          <td class="text-xs-center">
            {{ props.item.accountType }}
          </td>
          <td class="justify-center layout px-0">
            <v-icon
              small
              color="red lighten-2"
              @click="refundErecharge(props.item.transactionId, props.item.accountType)"
            >
              mdi-cash-refund
            </v-icon>
          </td>
          <v-snackbar
            v-model="snackbar2"
            :timeout="3000"
            top
            center
            :color="snackbarColor"
          >
            {{ snackbarText2 }}
            <template #action="{ attrs }">
              <v-btn
                color="white"
                text
                v-bind="attrs"
                @click="snackbar2 = false"
              >
                Close
              </v-btn>
            </template>
          </v-snackbar>
        </template>
      </v-data-table>
    </wide-panel>
  </v-scale-transition>
</template>

<script>
import { createGetParams, createPostParams } from '@/rest'

const pageTitle = 'Refund Billing'

export default {
  components: {
    WidePanel: () => import(/* webpackChunkName: "widePanel" */ '@/components/WidePanel'),
  },
  data: () => ({
    issueId: null,
    dialog: false,
    title: pageTitle,
    source: null,
    loading: false,
    deleteNewsDialog: false,
    deleteTopupDialog: false,
    refundDialog: false,
    transactionId: null,
    adjustment: [],
    erTransaction: [],
    items: [],
    breadcrumbs: [
      {
        text: 'Technical Kits',
        disabled: false,
        to: '/technical/technical_kits',
      },
      {
        text: pageTitle,
        disabled: true,
      },
    ],
    headers: [
      {
        text: 'Date',
        align: 'left',
        sortable: true,
        value: 'tarikh',
      },
      {
        text: 'Transaction ID',
        align: 'left',
        sortable: true,
        value: 'tarikh',
      },
      {
        text: 'Dreg',
        align: 'left',
        sortable: true,
        value: 'dealer',
      },
      {
        text: 'Msisdn',
        align: 'left',
        sortable: true,
        value: 'nohp',
      },
      {
        text: 'Amount',
        align: 'center',
        sortable: true,
        value: 'amaun',
      },
      {
        text: 'Kaedah',
        align: 'right',
        sortable: true,
        value: 'kaedah',
      },
      {
        text: 'Action',
        align: 'center',
        sortable: true,
        value: 'action',
      },
    ],
    headers2: [
      {
        text: 'Date',
        align: 'left',
        sortable: true,
        value: 'date',
      },
      {
        text: 'Dealer',
        align: 'left',
        sortable: true,
        value: 'dealer',
      },
      {
        text: 'Dreg',
        align: 'left',
        sortable: true,
        value: 'dreg',
      },
      {
        text: 'Msisdn',
        align: 'left',
        sortable: true,
        value: 'msisdn',
      },
      {
        text: 'Transaction ID',
        align: 'left',
        sortable: true,
        value: 'transactionId',
      },
      {
        text: 'Amount',
        align: 'left',
        sortable: true,
        value: 'amount',
      },
      {
        text: 'Transtype',
        align: 'center',
        sortable: true,
        value: 'transType',
      },
      {
        text: 'AccountType',
        align: 'center',
        sortable: true,
        value: 'accountType',
      },
      {
        text: 'Action',
        align: 'center',
        sortable: true,
        value: 'action',
      },
    ],
    editedIndex2: -1,
    editedIndex: -1,
    refundER: {
      id: null,
      amount: null,
      transactionId: null,
      accountType: null,
      dealer: null,
    },
    refundAmount: {
      id: null,
      dealer: null,
      amount: null,
    },
    defaultAmount: {
      id: null,
      dealer: null,
      amount: null,
    },
    formTitle: 'Refund Erecharge',
    validAmount: true,
    alertMessage: null,
    alert: false,
    alert2: false,
    executeDialog: false,
    executeAlertType: 'info',
    executeAlertMessage: null,
    snackbarText: null,
    snackbarText2: null,
    snackbarColor: null,
    snackbar: false,
    snackbar2: false,
    snackbarError: false,
  }),
  watch: {
    executeDialog (val) {
      if (val) {
        this.executeAlertType = 'info'
        this.executeAlertMessage =
          '<div>Please ensure that you have  <strong>deleted topup record </strong>from user before refund to dealer! .</div>'
      }
    },
    deleteNewsDialog (val) {
      val || this.closeAllDialogs2(false)
    },
    deleteTopupDialog (val) {
      val || this.closeAllDialogs(false)
    },
  },
  methods: {
    deleteItem (item) {
      const index = this.msisdns.indexOf(item)
      this.msisdns.splice(index, 1)
    },
    getAdjustmentInfo () {
      const params = createGetParams({
        transactionId: this.transactionId,
      })
      this.loading = true
      return this.$rest
        .get('getRefundBilling.php', params)
        .then((response) => {
          this.adjustment = response.data.topup
          this.erTransaction = response.data.transaction
          this.loading = false
          return response.data // Add this line if you need it in refreshList
        })
        .catch((error) => {
          console.log(error)
          this.loading = false
          throw error // Optional: rethrow if you want refreshList to catch it
        })
    },
    deleteTopup (id) {
      this.editedIndex = this.adjustment.indexOf(id)
      this.refundAmount = Object.assign({}, id)
      this.deleteTopupDialog = true
    },
    async deleteTopupRecord () {
      try {
        const params = createPostParams({
          action: 'deleteTopup',
          payload: {
            id: this.refundAmount.id,
          },
        })
        await this.$rest.post('postAction.php', params)

        this.snackbarText = 'You have successfully deleted a topup record'
        this.snackbar = true
        this.closeAllDialogs(true)
      } catch (error) {
        let message = error.message
        if (error.response) {
          message += ': ' + error.response.data
        }
        this.showError(message)
      }
    },
    refundErecharge (transactionId, accountType) {
      const transaction = this.erTransaction.find(
        t => t.transactionId === transactionId,
      )

      if (!transaction) {
        this.showError('Transaction not found.')
        return
      }

      this.refundER = {
        transactionId,
        accountType,
        dealer: transaction.dealer,
        amount: transaction.amount,
        id: transaction.id, // important for backend!
      }

      this.editedIndex2 = this.erTransaction.findIndex(
        t => t.transactionId === transactionId,
      )

      this.deleteNewsDialog = true
    },

    async refundErechargeDealer () {
      try {
        const params = createPostParams({
          action: 'refundBilling',
          payload: {
            id: this.refundER.id,
            transactionId: this.refundER.transactionId,
            accountType: this.refundER.accountType,
            dealer: this.refundER.dealer,
            amount: this.refundER.amount,
          },
        })

        const response = await this.$rest.post('postAction.php', params)

        // Backend may respond with success: false
        if (response.data && response.data.success) {
          this.closeAllDialogs2(true)
          this.snackbarText2 = 'You have successfully refunded the dealer'
          this.snackbar2 = true
          this.snackbarColor = 'success'
        } else {
          this.closeAllDialogs2(true)
          const msg = response.data && response.data.message
            ? response.data.message
            : 'Refund failed.'
          this.snackbarText2 = msg
          this.snackbar2 = true
          this.snackbarColor = 'warning'
        }
      } catch (error) {
        // Try to extract error message from backend
        let message = 'An unexpected error occurred.'

        if (error.response && error.response.data) {
          message = error.response.data.message || message
        } else if (error.message) {
          message = error.message
        }

        // Show error message in snackbar
        this.snackbarText2 = message
        this.snackbar2 = true
      }
    },

    refreshList (val) {
      this.getAdjustmentInfo(val).then((data) => {
        this.items = data.items
      })
    },
    closeAllDialogs (save) {
      this.dialog = false
      this.deleteTopupDialog = false
      this.alert = false
      setTimeout(() => {
        this.refundAmount = Object.assign({}, this.defaultItem)
        this.editedIndex = -1
        save && this.getAdjustmentInfo()
      }, 300)
    },
    closeAllDialogs2 (save) {
      this.dialog = false
      this.deleteNewsDialog = false
      this.alert2 = false
      setTimeout(() => {
        this.refundER = Object.assign({}, this.defaultItem2)
        this.editedIndex2 = -1
        save && this.getAdjustmentInfo()
      }, 300)
    },
    showError (message) {
      this.alertMessage = message
      this.alert = true
      this.alert2 = true
    },
  },
}
</script>
